import React from "react";
import NexusMenu from ".";
import { KEY_VALUES, LAYOUT, COLOR } from "../../modules/constants"
import { CHECKBOX } from "../../modules/checkbox_constants"
import { Checkboxes } from "./CommonMenu"
import { Collapse } from '@mui/material'

const addToMenu = props => {
  // console.log("addToMenu props:", props)
  setMenuDefaults(props)
  const { disabled, dontColorUnchecked, features, hooks, portrait, setAllCheckboxes, text, tooltipTitle, viewButtons } = props

  var checkboxGroup = []
  var checkboxItems = []
  const rollup = hooks ? props.rollups[hooks[0]] : null
  if (hooks) {
    hooks.forEach(hook => {
      checkboxGroup = checkboxGroup.concat(CHECKBOX[hook])
      checkboxItems = checkboxItems.concat(Checkboxes({ ...props, hook }))
    })
  }
  const hasCheckboxes = !!checkboxGroup.length
  const noneChecked = hasCheckboxes && !checkboxItems.some(item => item.checked === true)
  const allItemsChecked = hasCheckboxes && allChecked(checkboxItems)
  const someChecked = hasCheckboxes && !noneChecked && !allItemsChecked
  const collapsibleGroup = checkboxItems.length >= KEY_VALUES.MIN_CHECKBOXES_FOR_SELECT_ALL
  const opacity = checkboxItems.length ? checkboxItems[0].opacity : "100%"
  const enabled = checkboxItems[0]?.enabled

  return <div>

    {!text && !viewButtons && <Collapse in={rollup.status} timeout="auto" unmountOnExit style={{ paddingBottom: 15, marginTop: -5 }}>
      {collapsibleGroup &&
        <NexusMenu.Checkbox
          checked={allChecked(checkboxItems)}
          color={disabled ? COLOR.DISABLED : COLOR.MID_GREY}
          disabled={disabled}
          dontColorUnchecked={dontColorUnchecked}
          handleChange={() => setAllCheckboxes({ checked: !allChecked(checkboxItems), checkboxGroup, enabled, hooks })}
          indent={0}
          indeterminate={!checkboxItems.every(c => c.checked === checkboxItems[0].checked)}
          key={Math.floor(Math.random() * 10000)}
          label={allChecked(checkboxItems) ? "Deselect All" : "Select All"}
          noneChecked={noneChecked}
          opacity={opacity}
          portrait={portrait}
          tooltipTitle={tooltipTitle}
        />
      }

      {checkboxItems.map(checkbox => {
        const { bit, checked, color, count, enabled: itemEnabled, hook, label, labelColor, opacity, portrait, tooltipTitle } = checkbox
        // console.log("checkbox: ", checkbox)
        return (
          <NexusMenu.Checkbox
            checked={checked}
            color={disabled ? COLOR.DISABLED : color}
            disabled={disabled}
            dontColorUnchecked={dontColorUnchecked}
            handleChange={event => itemEnabled && checkbox.handleChange({ ...event.target, bit, hook })}
            indent={collapsibleGroup ? LAYOUT.CHECKBOX_LEFT_PADDING : 0}
            key={count}
            label={label}
            labelColor={disabled ? COLOR.DISABLED : labelColor}
            noneChecked={noneChecked}
            opacity={opacity}
            portrait={portrait}
            tooltipTitle={tooltipTitle}
          />
        )
      })}

    </Collapse>
    }

    {
      text && <NexusMenu.Text
        allItemsChecked={allItemsChecked}
        dontColorUnchecked={dontColorUnchecked}
        clickable={!!rollup}
        noneChecked={noneChecked}
        onClick={() => hooks ? props.handleRollupClick(hooks[0]) : null}
        rollupStatus={rollup?.status}
        selected={true}
        someChecked={someChecked}
        text={text.text}
        color={text.color}
        opacity={opacity}
        tooltipTitle={text.tooltipTitle}
      />
    }

    {
      viewButtons && // <Collapse in={rollup.status} timeout="auto" unmountOnExit>
      <NexusMenu.ViewButtons
        portrait={portrait}
        selected={true}
        viewButtons={viewButtons}
        features={features}
      />
      // </Collapse>
    }

  </div >
}

const allChecked = checkbox => checkbox.every(c => c.checked === true)

const setMenuDefaults = props => {
  // sets the default values for the title and option
  const { title, option } = props

  const defaults = {
    color: "black",
    fontSize: "large",
    tooltipTitle: "",
  }

  if (title)
    props.title = { ...defaults, ...title }

  if (option)
    props.option = { ...defaults, ...option }
}

export default addToMenu

